/**
 * ticket.palette — the ground values the in-app ticket card variants derive
 * from, as data: the near-black ink ground and the warm paper ground
 * (editorial/strata's two-tone split), plus the vivid-orange stencil ground
 * (stencil's single-tone card), each a `{ background, ink }` pair. The
 * card's `<style>` block reads them (ticket-inapp.palette.ts, whose header
 * owns the WHY of pinning these values rather than reading theme tokens), so
 * a hex edit here moves the card wherever it renders — the order page, the
 * emailed PDF, the share PNG.
 *
 * These grounds are pinned because every variant draws its own QR with
 * literal-black modules and any movement in the ground moves a scanner's
 * contrast. THE WALLET PASSES' GROUND COLOUR IS THE ONLY THING THAT TAKES NO
 * COLOUR FROM HERE for a seed-derived variant (editorial/strata) — Apple and
 * Google draw the barcode themselves on their own white plate, so a
 * seed-derived pass ground carries no scan duty and is free to be the fork's
 * brand instead (ticket-wallet.design.ts derives it from the brand seed). A
 * PINNED variant (stencil) is the opposite case: its pass ground, AND its
 * field ink, ARE this literal, read across whole.
 *
 * WHITE INK ON THIS GROUND MEASURES 2.91:1 — under the 4.5:1 floor small
 * field text needs. `ticket-wallet.design.ts`'s pinned branch ships it
 * anyway: a CONFIRMED, RECORDED product decision (not a default, not an
 * oversight) to hold stencil's pass to brand-exact parity with the card
 * over the WCAG floor the card itself already accepts missing — see that
 * file's own header for the fuller account and `ticket-wallet.design.test.ts`
 * for the test that once asserted the opposite and was deliberately changed.
 *
 * `STENCIL_LABEL_OPACITY`/`STENCIL_VALUE_OPACITY` are the card's own
 * `.tkt-stencil-label`/`.tkt-stencil-value` opacity rules
 * (ticket-inapp.styles.ts), read back here rather than re-declared: a pass
 * field's ink has no `opacity` channel to send Apple (`foregroundColor` is a
 * flat RGB), so `ticket-wallet.design.ts` pre-blends `TICKET_GROUNDS.stencil`
 * against these same two fractions instead of guessing its own.
 */
export type TicketGround = { background: string; ink: string };

export const TICKET_GROUNDS: {
	ink: TicketGround;
	paper: TicketGround;
	stencil: TicketGround;
} = {
	ink: { background: "#110e09", ink: "#ebe1d9" },
	paper: { background: "#ebe1d9", ink: "#352f2a" },
	stencil: { background: "#F5701A", ink: "#ffffff" },
};

/** The stencil card's own `.tkt-stencil-label` opacity (full — no dim rule
 *  applies to it) and `.tkt-stencil-value` opacity (ticket-inapp.styles.ts).
 *  Stencil inverts editorial/strata's own convention (`.tkt-dim`, 0.7,
 *  applied to the LABEL there) — its VALUE is the dimmed tier instead. */
export const STENCIL_LABEL_OPACITY = 1;
export const STENCIL_VALUE_OPACITY = 0.85;
